// extracted by css-extract-rspack-plugin
export default {"box":"box___s97mU","left":"left___QwjHV","radio":"radio___73Poj","right":"right___y2z-o","right_table":"right_table___WVNRp"};